import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { AppTokenService } from "../../app-token.service";
import { HttpHandlerService } from "../../http-handler.service";

@Injectable({ providedIn: 'root' })

export class VendorRecoService {
    _httpHandler: HttpHandlerService;
    _apiUrl = environment.apiUrl;
    _getAllEndPoint = 'invoice/vendorreco';

    constructor(private httpHandler: HttpHandlerService, private appTokenService: AppTokenService) {
        this._httpHandler = httpHandler;
    }

    public Add(data: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getAllEndPoint}`;
        const request_options = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            data
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public GetAllList(params?: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getAllEndPoint}/list?pagelimit=${params?.length}&pageoffset=${params?.start}`
        const request_option = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this
            .httpHandler.request(request_option, this.appTokenService.tokenizedResponse);
    }

    public GetVendorRecoInfoById(userId: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getAllEndPoint}/${userId}`;
        const request_options = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public GetVendorRecoDetailListById(userId: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getAllEndPoint}/list/${userId}`;
        const request_options = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public DeleteVendorRecoById(userId: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getAllEndPoint}/${userId}`;
        const request_option = this._httpHandler.prepareRequest('DELETE', full_api_url, {});
        return this._httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }

    public DeleteVendorDetailRecoById(userId: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getAllEndPoint}/detail/${userId}`;
        const request_option = this._httpHandler.prepareRequest('DELETE', full_api_url, {});
        return this._httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }

    public updateVendorRecoDetail(userData: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getAllEndPoint}/update`;
        const request_options = this._httpHandler.prepareRequest(
            'PUT',
            full_api_url,
            userData
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }
}